/**
 * Route configuration for the AMLPro module.
 * NB: This is not the configuration for the settings that will be used by the AMLPro module.
 * The settings configuration is in the global-settings folder.
 */

import AMLProLayout from '@/modules/amlpro/layout/AmlProLayout.vue';
import AmlCaseDetail from '../views/components/aml-cases/AmlCaseDetail.vue';
import AmlCaseDashboard from '../views/components/aml-cases/AmlCaseDashboard.vue';
import FlaggedAttempts from '../views/components/flagged-attempts/FlaggedAttempts.vue';
import FlaggedAttemptDetail from '../views/components/flagged-attempts/FlaggedAttemptDetail.vue';
import WatchlistDashboard from '../views/components/watchlist/WatchlistDashboard.vue';
import WatchlistSearch from '../views/components/watchlist/WatchlistSearch.vue';
import WatchlistFlagDetail from '../views/components/watchlist/WatchlistFlagDetail.vue';
import WatchlistCaseDetail from '../views/components/watchlist/WatchlistCaseDetail.vue';
import WatchlistCases      from '../views/components/watchlist/WatchlistCases.vue';
import WatchlistSearchReports from '../views/components/watchlist/WatchlistSearchReports.vue';

const routes = [
  {
    path: 'member-profile',
    name: 'member-profile',
    component: () => import('@/modules/amlpro/views/MemberProfilePage.vue')
  },
  {
    path: 'mass-processing',
    name: 'mass-processing',
    component: () => import('@/modules/amlpro/views/MassProcessingDashboard.vue')
  },
  {
    path: 'mass-kyc-risk-processing',
    name: 'mass-kyc-risk-processing',
    component: () => import('@/modules/amlpro/views/components/mass-processing/MassKycRiskProcessing.vue')
  },
  {
    path: 'mass-global-trends-processing',
    name: 'mass-global-trends-processing',
    component: () => import('@/modules/amlpro/views/components/mass-processing/MassGlobalTrendsProcessing.vue')
  },
  {
    path: 'mass-exceptions-management',
    name: 'mass-exceptions-management',
    component: () => import('@/modules/amlpro/views/components/mass-processing/MassExceptionsManagement.vue')
  },
  {
    path: 'aml-case-dashboard',
    name: 'aml-case-dashboard',
    component: AmlCaseDashboard,
  },
  {
    path: 'aml-cases/:id',
    name: 'aml-case-detail',
    component: AmlCaseDetail,
    props: true
  },
  {
    path: 'flagged-attempts',
    name: 'flagged-attempts',
    component: FlaggedAttempts,
  },
  {
    path: 'flagged-attempts/:id',
    name: 'flagged-attempt-detail',
    component: FlaggedAttemptDetail,
    props: true,
  },
  {
    path: 'watchlist-dashboard',
    name: 'watchlist-dashboard',
    component: WatchlistDashboard,
    meta: { title: 'Watchlist Dashboard', transition: 'fade' },
  },
  {
    path: 'watchlist/search',
    name: 'watchlist-search',
    component: WatchlistSearch,
    meta: { title: 'Watchlist Search', transition: 'fade' },
  },
  {
    path: 'watchlist/search-reports',
    name: 'watchlist-search-reports',
    component: WatchlistSearchReports,
    meta: { title: 'Search Reports', transition: 'fade' },
  },
  {
    path: 'watchlist/flags/:flagId',
    name: 'watchlist-flag-detail',
    component: WatchlistFlagDetail,
    props: true,
    meta: { title: 'Flag Detail', transition: 'fade' },
  },
  {
    path: 'watchlist/cases',
    name: 'watchlist-cases',
    component: WatchlistCases,
    meta: { title: 'Watchlist Cases', transition: 'fade' },
  },
  {
    path: 'watchlist/cases/:caseId',
    name: 'watchlist-case-detail',
    component: WatchlistCaseDetail,
    props: true,
    meta: { title: 'Watchlist Case', transition: 'fade' },
  },
];
 
export default {
  path: 'aml-pro',
  name: 'aml-pro',
  component: AMLProLayout,
  redirect: { name: 'mass-processing' },
  meta: { requiresAuth: true },
  children: [...routes]
};